export enum VisitStatus {
    NEAR = 'near',
    VISITED = 'visited',
    NOT_VISITED = 'not_visited',
}
